export const normalizePropertyNames = <T>(items: T[]) => {
  return items;
};
